var map = {
	"./account.svg": 31500,
	"./approval.svg": 68882,
	"./arrow.svg": 5778,
	"./attention.svg": 17475,
	"./bank.svg": 21493,
	"./banks/bank-of-ireland.svg": 4283,
	"./banks/bank-of-scotland.svg": 39394,
	"./banks/barclays.svg": 95808,
	"./banks/clydesdale-bank.svg": 81816,
	"./banks/danske-bank.svg": 27370,
	"./banks/first-direct.svg": 36587,
	"./banks/first-trust-bank.svg": 33941,
	"./banks/halifax.svg": 84176,
	"./banks/hsbc.svg": 51949,
	"./banks/lloyds-bank.svg": 21419,
	"./banks/metro-bank.svg": 46633,
	"./banks/monzo.svg": 77298,
	"./banks/nationwide.svg": 48995,
	"./banks/natwest.svg": 43309,
	"./banks/royal-bank-of-scotland.svg": 80668,
	"./banks/santander.svg": 47349,
	"./banks/starling-bank.svg": 89810,
	"./banks/tesco-bank.svg": 32246,
	"./banks/the-co-operative-bank.svg": 32478,
	"./banks/thinkmoney.svg": 2903,
	"./banks/tsb.svg": 31478,
	"./banks/ulster-bank.svg": 42843,
	"./banks/yorkshire-bank.svg": 36294,
	"./beers.svg": 54876,
	"./bell.svg": 33960,
	"./briefcase.svg": 93329,
	"./broken-heart.svg": 86167,
	"./bubble.svg": 19885,
	"./burger.svg": 39040,
	"./car.svg": 36363,
	"./cash.svg": 71326,
	"./check.svg": 64261,
	"./chevron.svg": 48976,
	"./claim.svg": 36685,
	"./close-thin.svg": 86275,
	"./close.svg": 27409,
	"./coins.svg": 50007,
	"./computer.svg": 41800,
	"./cool.svg": 85868,
	"./cost.svg": 9576,
	"./cross-thin.svg": 18507,
	"./cross.svg": 47625,
	"./crown.svg": 25344,
	"./document-address.svg": 61187,
	"./document-generic.svg": 74532,
	"./document-income.svg": 57088,
	"./document-payslip.svg": 56295,
	"./document-upload.svg": 16730,
	"./envelope-red.svg": 92301,
	"./envelope.svg": 52159,
	"./examine.svg": 19896,
	"./experts.svg": 96178,
	"./eye.svg": 102,
	"./finances.svg": 70214,
	"./folder.svg": 77223,
	"./grimace.svg": 58143,
	"./home.svg": 7706,
	"./hourglass.svg": 85703,
	"./id.svg": 55152,
	"./info-thin.svg": 92201,
	"./info.svg": 17167,
	"./key.svg": 20124,
	"./letter.svg": 58375,
	"./link.svg": 65203,
	"./lock-new.svg": 96371,
	"./lock.svg": 26190,
	"./man.svg": 47661,
	"./map-pin-tip.svg": 33065,
	"./map-pin.svg": 35537,
	"./menu.svg": 28358,
	"./minus.svg": 89773,
	"./mugshot.svg": 22336,
	"./open-banking.svg": 65274,
	"./papers.svg": 27178,
	"./party-popper.svg": 33548,
	"./phone.svg": 86445,
	"./pin-new.svg": 83129,
	"./pin.svg": 9668,
	"./placeholders/addresses.svg": 89352,
	"./placeholders/documents.svg": 61398,
	"./placeholders/employers.svg": 32170,
	"./placeholders/expenses.svg": 81355,
	"./placeholders/vehicles.svg": 67023,
	"./placeholders/workplaces.svg": 39627,
	"./plus-blue.svg": 68292,
	"./plus-white.svg": 29103,
	"./plus.svg": 39583,
	"./preferences.svg": 64071,
	"./question-mark.svg": 34883,
	"./questionnaire-customers.svg": 17930,
	"./questionnaire-refund.svg": 44317,
	"./receive_refund.svg": 30951,
	"./refresh.svg": 76772,
	"./rocket-ship.svg": 91662,
	"./rocket.svg": 62335,
	"./scroll.svg": 68956,
	"./security.svg": 43433,
	"./settings.svg": 31992,
	"./shirt.svg": 7825,
	"./smartphone.svg": 69342,
	"./smug.svg": 34359,
	"./snap.svg": 76615,
	"./social/facebook.svg": 45857,
	"./social/tiktok.svg": 13419,
	"./social/x.svg": 62839,
	"./speak_to_us.svg": 55260,
	"./speech-bubbles.svg": 20843,
	"./success.svg": 15200,
	"./telephone-old.svg": 90009,
	"./telephone-red.svg": 2127,
	"./telephone.svg": 2965,
	"./thumb-up.svg": 75237,
	"./timer.svg": 1486,
	"./trash-grey.svg": 46657,
	"./trash.svg": 60047,
	"./upload.svg": 90892,
	"./vehicle.svg": 80077,
	"./warning.svg": 77485,
	"./zzz.svg": 46311
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70620;